import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logoImg from '../../assets/LogoDexa.png';

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-container">
        
        {/* Main Footer Grid */}
        <div className="footer-top-grid">
          
          {/* Brand Info Column */}
          <div className="footer-brand-col">
            <Link to="/" className="footer-logo">
              <img src={logoImg} alt="DEXA Technovation" className="footer-logo-img" />
            </Link>
            <p className="footer-brand-desc">
              Dexa Technovation is a global leader in high-performance CNC solutions.
            </p>
          </div>

          {/* Links Column 1: Pages */}
          <div className="footer-links-col">
            <h4 className="footer-col-heading">Pages</h4>
            <ul className="footer-links-list">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/services">Machines</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
            </ul>
          </div>

          {/* Links Column 2: Resources */}
          <div className="footer-links-col">
            <h4 className="footer-col-heading">Resources</h4>
            <ul className="footer-links-list">
              <li><Link to="/services">Software</Link></li>
              <li><Link to="/solutions">Warranty Services</Link></li>
              <li><Link to="/contact">Support</Link></li>
            </ul>
          </div>

          {/* Links Column 3: Social */}
          <div className="footer-links-col">
            <h4 className="footer-col-heading">Social</h4>
            <ul className="footer-links-list">
              <li><a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a></li>
              <li><a href="https://youtube.com" target="_blank" rel="noopener noreferrer">Youtube</a></li>
              <li><a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">Linkedin</a></li>
            </ul>
          </div>

          {/* Links Column 4: Industrial HQ */}
          <div className="footer-links-col footer-hq-col">
            <h4 className="footer-col-heading">Industrial HQ</h4>
            <p className="footer-address">
              33, 44, Bhaktavatsalam Nagar, Manali, Chennai, Tamil Nadu 600051, India
            </p>
            <p className="footer-contact-item">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
              <span>+91 88255 30173</span>
            </p>
            <p className="footer-contact-item">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
              <span>consult@dexatechnovation.com</span>
            </p>
          </div>

        </div>

        {/* Bottom Copyright Bar */}
        <div className="footer-bottom-bar">
          <p>© {new Date().getFullYear()} Dexa Technovation. All rights reserved. Developed by <a href="https://ascentbrandworks.com" target="_blank" rel="noopener noreferrer" className="ascent-link">ASCENT BRANDWORKS.</a></p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
